import axios from 'axios';

// Shared bits of the LAN party pages.

// Only http(s) links; anything else (javascript:, data:) renders no link.
export function safeHttpUrl(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

// "pimpcs" out of https://www.twitch.tv/pimpcs, null for any other channel.
export function twitchLogin(value) {
  const url = safeHttpUrl(value);
  if (!url) return null;
  const { hostname, pathname } = new URL(url);
  const match = pathname.match(/^\/([A-Za-z0-9_]+)\/?$/);
  const twitch = hostname === 'twitch.tv' || hostname.endsWith('.twitch.tv');
  return twitch && match ? match[1] : null;
}

export function pinUrl(mapName) {
  return `/maps/${mapName.toLowerCase()}_pin.png`;
}

// First the error the API named, then a fallback.
export function apiError(error, fallback) {
  const data = error?.response?.data;
  return (Array.isArray(data?.errors) ? data.errors[0] : data?.error) || fallback;
}

const TWITCH_RETURN_KEY = 'twitch_return_to';

// Sends the browser to Twitch: a viewer link, or with a slug the Creator's channel connection.
// /twitch/callback brings it back to the page it left.
export function startTwitchLink(creatorSlug = null) {
  const url = creatorSlug ? `/creators/${creatorSlug}/twitch_connection/new` : '/twitch/link/new';
  return axios.get(url).then(({ data }) => {
    sessionStorage.setItem(TWITCH_RETURN_KEY, window.location.pathname + window.location.search);
    window.location.assign(data.url);
  });
}

export function takeTwitchReturn() {
  const path = sessionStorage.getItem(TWITCH_RETURN_KEY);
  sessionStorage.removeItem(TWITCH_RETURN_KEY);
  return path?.startsWith('/') && !path.startsWith('//') ? path : '/';
}
